import { render, staticRenderFns } from "./widgetSysModifyList.vue?vue&type=template&id=65682e8c&scoped=true&"
import script from "./widgetSysModifyList.vue?vue&type=script&lang=js&"
export * from "./widgetSysModifyList.vue?vue&type=script&lang=js&"
import style0 from "./widgetSysModifyList.vue?vue&type=style&index=0&id=65682e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65682e8c",
  null
  
)

export default component.exports